import React, { useState } from 'react';

import Counter from '../common/components/organisms/Counter';
import classNames from 'classnames/bind';
import styles from './styles.module.scss';

const cx = classNames.bind(styles);
function CounterComponent() {
  const [min, setMin] = useState(2);
  const [max, setMax] = useState(10);
  const [letter, setLetter] = useState('');
  const [value, setValue] = useState(2);
  return (
    <div className={cx('counter')}>
      최소값 :{' '}
      <input
        placeholder="min 값"
        value={min}
        onChange={(e) => {
          setMin(e.target.value);
        }}
      />
      <br />
      최대값 : <input placeholder="max 값" value={max} onChange={(e) => setMax(e.target.value)} />
      <br />
      문자 :{' '}
      <input placeholder="문자열" value={letter} onChange={(e) => setLetter(e.target.value)} />
      <Counter
        minCount={min}
        maxCount={max}
        currentValue={value}
        currentCount={(e) => setValue(e)}
        formatLetter={letter}
      />
    </div>
  );
}
export default CounterComponent;

export const path = '/counter';
